<template>
  <v-container class="main-container responsive-height mt5-wrapper">
    <v-row dense>
      <v-col cols="12" class="position-relative">
        <div class="mt5-create-account">
          <CreateAccountDropdown></CreateAccountDropdown>
        </div>
        <Mt5AllTabs></Mt5AllTabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CreateAccountDropdown from "@/components/GlobalComponents/CreateAccountDropdown";
import Mt5AllTabs from "@/components/PagesComponents/Mt5Page/Mt5AllTabs";
export default {
  components: {
    Mt5AllTabs,
    CreateAccountDropdown,
  },
};
</script>

<style>
.mt5-wrapper {
  width: 100%;
  max-width: none;
  padding: 22px 24px 36px;
  background: #f7f8fa;
}

.theme--dark .mt5-wrapper {
  background: #030b13;
}

.mt5-wrapper .mt5-create-account {
  top: 0;
  right: 4px;
}

.mt5-wrapper .mt5-create-account .v-btn {
  height: 38px !important;
  padding: 0 15px !important;
  color: #b47f00 !important;
  background: transparent !important;
  border: 1px solid #d99a00;
  border-radius: 5px !important;
  box-shadow: none !important;
}

.theme--dark .mt5-wrapper .mt5-create-account .v-btn {
  color: #ffc400 !important;
  border-color: #d99a00;
}

.mt5-wrapper .mt5-create-account .v-btn .v-icon,
.mt5-wrapper .mt5-create-account .v-btn .v-btn__content {
  color: inherit !important;
}

@media (max-width: 700px) {
  .mt5-wrapper {
    width: 100%;
    height: calc(100dvh - 56px);
    padding: 14px 12px 32px;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .mt5-wrapper .mt5-create-account {
    position: static !important;
    display: flex;
    width: 100%;
    margin: 2px 0 12px;
    justify-content: flex-end;
  }
  .mt5-wrapper .mt5-create-account .v-btn {
    width: auto !important;
    max-width: 100%;
  }
}
</style>
